import React from "react";
import { compose, graphql } from "react-apollo";
import { withQuery } from "containers/withQuery";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import ActuatorModal from "./ActuatorModal";
import { ACTUATOR_QUERY, ACTUATORS_QUERY } from "../generalRegisterQueries";
import { UPDATE_ACTUATOR_MUTATION } from "../generalRegisterMutations";

const ActuatorEdit = ({
  actuator,
  updateActuator,
  id,
  snackbarContext,
  onFinishEdit,
}) => {
  const onSave = (newActuator) => {
    updateActuator({
      variables: {
        id,
        params: newActuator
      },
      refetchQueries: [{
        query: ACTUATORS_QUERY
      }]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Atuador atualizado.");
        onFinishEdit();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  }
  return (
    <ActuatorModal
      toggleModal={onFinishEdit}
      isOpen={id}
      onSave={onSave}
      {...actuator}
      title="Editar atuador"
    />
  );
}

export default compose(
  withQuery(({ id }) => ({
    query: ACTUATOR_QUERY,
    variables: {
      id,
    },
    noLoader: true,
  })),
  graphql(UPDATE_ACTUATOR_MUTATION, { name: "updateActuator", }),
  withSnackbarConsumer,
)(ActuatorEdit);
